import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Switch } from "antd";
import axios from "axios";
import AnnouncementModal from "../../../../components/modelpopup/AnnouncementForm";
import Swal from "sweetalert2";
import SearchBox from "../../../../components/SearchBox";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingAnnouncement, setEditingAnnouncement] = useState(null);
  const [isFullScreen, setFullScreen] = useState(false);
  const maximizeBtnRef = useRef(null);
  const dateFormat = localStorage.getItem("dateFormat") || "MMM DD, YYYY";
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${apiUrl}/announcements/list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setAnnouncements(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching announcements:", error);
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, [token]);

  const onSubmit = (responseData) => {
    const updatedAnnouncements = editingAnnouncement
      ? announcements.map((ann) =>
          ann.id === responseData.id ? responseData : ann
        )
      : [...announcements, responseData];

    setAnnouncements(updatedAnnouncements);
    setEditingAnnouncement(null);
  };

  const deleteAnnouncement = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this announcement!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}/announcements/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setAnnouncements(announcements.filter((ann) => ann.id !== id));
        toast.success("Announcement has been deleted.");
      } catch (error) {
        let errorMessage = "Failed to delete announcement. Please try again later.";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        Swal.fire("Error!", errorMessage, "error");
      }
    }
  };

  const handleEditClick = (announcement) => {
    setEditingAnnouncement(announcement);
  };

  const handleAddClick = () => {
    setEditingAnnouncement(null);
  };

  const handleStatusChange = async (id) => {
    const updatedAnnouncements = announcements.map((item) =>
      item.id === id ? { ...item, status: !item.status } : item
    );
    setAnnouncements(updatedAnnouncements);
    // Optionally, send a request to update the status in the backend
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      width: "20%",
    },

    {
      title: "Published Date",
      dataIndex: "published_date",
      render: (date) => (date ? moment(date).format(dateFormat) : "-"),
      sorter: (a, b) => moment(a.published_date).diff(moment(b.published_date)),
      width: "20%",
    },
    {
      title: "Created By",
      dataIndex: "createdbyname",
      sorter: (a, b) => a.createdbyname.localeCompare(b.createdbyname),
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status, record) => (
        <Switch
          checked={status}
          onChange={() => handleStatusChange(record.id)}
        />
      ),
      width: "10%",
    },
    {
      title: "Action",
      render: (_, record) => (
        <div className="dropdown dropdown-action">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={() => handleEditClick(record)}
              data-bs-toggle="modal"
              data-bs-target="#add_announcement"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteAnnouncement(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "20%",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
              <h3 className="page-title">Announcements</h3>
            </div>
            <div className="col-md-8 float-end ms-auto">
              <div className="d-flex title-head">
                <div className="view-icons">
                  <Link to="#" className="grid-view btn btn-link">
                    <i className="las la-redo-alt" />
                  </Link>
                  <Link
                    to="#"
                    className="list-view btn btn-link"
                    id="collapse-header"
                    ref={maximizeBtnRef}
                  >
                    <i className="las la-expand-arrows-alt" />
                  </Link>
                </div>
                <Link
                  to="#"
                  className="btn add-btn custom-btn"
                  onClick={() => handleAddClick()}
                  data-bs-toggle="modal"
                  data-bs-target="#add_announcement"
                >
                  <i className="la la-plus-circle custom-icon" /> Add New
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <SearchBox />
              <Table
                columns={columns}
                dataSource={announcements}
                loading={loading}
                rowKey={(record) => record.id}
              />
            </div>
          </div>
        </div>
      </div>
      <AnnouncementModal
        onSubmit={onSubmit}
        announcementData={editingAnnouncement}
      />
    </div>
  );
};

export default Announcements;
